function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,128C256,57.307 198.693,0 128,0C57.307,0 0,57.307 0,128C0,191.889 46.808,244.843 108,254.445L108,165L75.5,165L75.5,128L108,128L108,99.8C108,67.72 127.11,50 156.348,50C170.352,50 185,52.5 185,52.5L185,84L168.86,84C152.959,84 148,93.867 148,103.989L148,128L183.5,128L177.825,165L148,165L148,254.445C209.192,244.843 256,191.889 256,128",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.078bbb9549b61ff9880044c1bd603120.svg";
export { ForwardRef as ReactComponent };